

















import React from "react";
import { Link } from "react-router-dom";
import "../styles/JointVenturePartners.css";

// Import your icon and image
import partnerIcon from "../assets/icons/partner-icon.png";
import partnerImage from "../image/Partner-image.png";

const JointVenturePartners = () => {
  return (
    <div className="jvp-container">
      {/* Image Slider */}
      <div className="jvp-image-slider">
        <img src={partnerImage} alt="Joint Venture Partners Slider" />
      </div>

      {/* Main Content Container */}
      <div className="jvp-content">
        {/* Content Card with title inside */}
        <div className="jvp-card">
          {/* Ship wheel icon and title */}
          <div className="jvp-header-container">
            <img src={partnerIcon} alt="Partners" className="jvp-wheel-icon" />
            <div className="jvp-header-title">Joint Venture Partners</div>
          </div>
          
          {/* Content */}
          <div className="jvp-text-content">
            <p className="jvp-text">
              ECL Shipping India Pvt. Ltd. is associated with ECL (Singapore) Pte. Ltd., which is a major shareholder in the company. ECL (Singapore) Pte. Ltd. represents the ECL Group’s interests and plays a key role in supporting ECL Shipping’s operations in the region.
            </p>
            
            {/* <h3 className="jvp-subtitle">ECL (SINGAPORE) PTE LTD :</h3> */}
            <p className="jvp-text">
             ECL (Singapore) Pte. Ltd. is a wholly owned subsidiary of Eastern Car Liner Ltd., Japan, and acts as the General Agent in Singapore. It functions as a vital link between Eastern Car Liner Ltd., Japan and the other General Agents appointed across South-East Asian and West Asian countries. Eastern Car Liner Ltd., Japan was established in May 1977 with the vision of providing transportation services to South-East Asia under the slogan “Pioneering Frontiers.”
            </p>
            
            <p className="jvp-text">
             Eastern Car Liner Ltd., Japan operates a fleet of Pure Car and Truck Carriers (PCTC) and multipurpose vessels with lifting capacities of up to 120 tons, offering more than 50 sailings per month to destinations including China, Korea, South-East Asia, the US West Coast, India, and the Persian Gulf. As operators, ECL (Singapore) Pte. Ltd. provides pendular services from South-East Asia and China to the Indian Ocean, along with time-bound and regular transshipment sailings from Singapore to nearby destinations through its extensive network.
            </p>
           
            
           
          </div>
          
          {/* Right Side Panel */}
          <div className="jvp-side-panel">
            <Link to="/overview" className="jvp-panel-link">
              <div className="jvp-panel-section">
                <h4 className="jvp-panel-title">Overview :</h4>
                <p className="jvp-panel-text">
                ECL Shipping India Pvt Ltd was established in 2025 as a joint venture of ECL (Singapore) Pte Ltd, a 100 percent subsidiary of M/s. Eastern Car Liner, Japan.
ECL-Shipping acts as the General Agent in India for M/s. Eastern Car Liner, one of the largest breakbulk operators from Japan.
</p>
              </div>
            </Link>
            
            <Link to="/management-standards-vision" className="jvp-panel-link">
              <div className="jvp-panel-section">
                <h4 className="jvp-panel-title">Management, Standards & Vision :</h4>
                <p className="jvp-panel-text">
                  The Top management of the Company has a combined experience of more than ten decades in the Shipping Industry.
                </p>
              </div>
            </Link>
            
          
          </div>
        </div>
      </div>
    </div>
  );
};

export default JointVenturePartners;